import r from "../core/AxiosError.js";
import i from "../utils.js";
function l(o, t, e) {
  r.call(this, o !== null && o !== void 0 ? o : "canceled", r.ERR_CANCELED, t, e), this.name = "CanceledError";
}
i.inherits(l, r, {
  __CANCEL__: !0
});
export { l as default };
